    import styles from "./FromComponent.module.css";

    const CheckBox = ({ checked, handleChange }) => {
    return (
        <input
        checked={checked || false}
        type="checkbox"
        onChange={handleChange}
        className={styles.cb_1}
        />
    );
    };

    export default CheckBox;
